import { render, staticRenderFns } from "./AlterarSenha.vue?vue&type=template&id=ef14d8fe&scoped=true"
import script from "./AlterarSenha.vue?vue&type=script&lang=js"
export * from "./AlterarSenha.vue?vue&type=script&lang=js"
import style0 from "./AlterarSenha.vue?vue&type=style&index=0&id=ef14d8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef14d8fe",
  null
  
)

export default component.exports